import React from "react";
import { Controller, useForm } from "react-hook-form";

import { CCol, CCollapse, CRow } from "@coreui/react";

import { TRANG_THAI_NCC_OPTIONS } from "src/1/common/constants/variables";
import { filter as filterFunc } from "src/utils/funcs";

import { Magnifying } from "_assets/icons";
import { CButton, CDate, CInput, CSelect } from "_components/controls";
import { CActionGroup } from "_components/others";

export const NCCToolbar = ({ params, canEdit, onEdit, onSearch }) => {
  //#region Data
  const { control, handleSubmit } = useForm({
    defaultValues: params,
  });
  //#endregion

  //#region Event
  const onClick = (state) => {
    switch (state) {
      case "edit":
        return onEdit();
      default:
        return;
    }
  };

  const search = handleSubmit((d) => onSearch(filterFunc(d)));
  //#endregion

  //#region Render
  return (
    <>
      <CRow>
        <CCol xs="12" className="action">
          <div>
            <CActionGroup
              onClick={onClick}
              canAdd={false}
              canEdit={canEdit}
              canRemove={false}
            />
          </div>
        </CCol>
      </CRow>

      <CCollapse show>
        <div className="mt-3 flex justify-between items-end">
          <div className="flex items-center gap-3">
            <div className="min-w-[200px]">
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <CInput
                    label="Tên nhà cung cấp:"
                    placeholder="Tìm theo tên NCC"
                    {...field}
                  />
                )}
              />
            </div>
            <div className="w-[200px]">
              <Controller
                name="active"
                control={control}
                render={({ field }) => (
                  <CSelect
                    label="Trạng thái:"
                    optionAll
                    select="value"
                    options={TRANG_THAI_NCC_OPTIONS}
                    {...field}
                  />
                )}
              />
            </div>
            <div className="w-[200px]">
              <Controller
                name="start_at"
                control={control}
                render={({ field }) => (
                  <CDate label="Bắt đầu cung cấp từ:" {...field} />
                )}
              />
            </div>
            <div className="w-[200px]">
              <Controller
                name="end_at"
                control={control}
                render={({ field }) => <CDate label="Đến:" {...field} />}
              />
            </div>
          </div>

          <div className="form-group c-input">
            <CButton icon={<Magnifying />} onClick={search} className="m-0">
              Tìm kiếm
            </CButton>
          </div>
        </div>
      </CCollapse>
    </>
  );
  //#endregion
};
